// Constants
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import CustomerConstants from '../../constants/column-name/customer.column-name.constants';
import CustomerFormConstants from '../../constants/form/customer.form.constants';
import Mappings from './CustomerAutoCompleteMaps';

export default Vue.component('window', {
  beforeCreate() {
    // eslint-disable-next-line global-require
    this.$options.components.AutoComplete = require('../shared/AutoComplete.vue').default;
  },
  template: `  <AddEditForm title='${
    CustomerFormConstants.FormTitle
  }' ref="addEditForm" @submit-button-clicked="onFormSubmit" @dialog-closed="handleDialogClosed">
    <div class="flex-container">
      <div class="flex-column">
        <h3>Basic Information</h3>
        ${FormDataService.textInput(CustomerConstants.customerCode)}
        ${FormDataService.textInput(CustomerConstants.customerName)}
        ${FormDataService.textInput(CustomerConstants.attention)}
        ${FormDataService.textareaInput(CustomerConstants.address)}
        <AutoComplete
        :formData="formData"
        :clearRightPadding="true"
        openDirection="above"
        :mapping="mappings.ThirdParty"
        store="ThirdParty"
        placeholder="Select Third Party"
        :allowAdditions="true"
        :removeOptionsLimit="true"
      >Third Party </AutoComplete>
        ${FormDataService.textareaInput(CustomerConstants.comments, 10)}
      </div>
      <div class="flex-column">
        <h3>Contact Information</h3>
        ${FormDataService.textInput(CustomerConstants.phone)}
        ${FormDataService.textInput(CustomerConstants.fax)}
        ${FormDataService.textInput(CustomerConstants.email)}
        ${FormDataService.textareaInput(CustomerConstants.allReportEmails)}
        ${FormDataService.textareaInput(CustomerConstants.goodReportEmails)}
        ${FormDataService.textareaInput(CustomerConstants.badReportEmails)}
      </div>
    </div>
  </AddEditForm>`,
  name: CustomerFormConstants.FormName,
  data() {
    return {
      formData: {},
      mappings: Mappings
    };
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm(isEdit) {
      const errors = this.checkFormSubmission(CustomerConstants);
      if (!this.validEmail(this.formData.email) && !isEdit && this.formData.email && this.formData.email !== '') {
        errors.push('Valid email required.');
      }
      return errors;
    },
    handleDialogClosed() {
      // Emit the event up to parent components
      this.$emit('dialog-closed');
    }
  },
  components: {
    AddEditForm
  }
});
